module.exports = __webpack_public_path__ + "img/Vector2.0733a298.svg";